// APL-11850 iPad boot triage — the take route's lazy chunk downloads via
// native import(), which none of the netDebugLog patches (fetch/XHR/axios)
// can see. This one label marks that phase inside the take-shell Suspense
// fallback so a boot stuck on the chunk download can be told apart from a
// stuck request ("panel says 0 pending" + this label = chunk download).
// Debug-only surface: same isNetDebugEnabled gate + hardcoded-English
// precedent as NetDebugPopover, and deliberately NOT plumbed into any other
// skeleton (dev scoped the labelling to the debug panel approach).
import { isNetDebugEnabled } from '@/lib/netDebugLog';

export const NetDebugChunkLabel = () => {
  if (!isNetDebugEnabled()) return null;
  return (
    <div
      data-testid="net-debug-chunk-label"
      className="fixed bottom-14 start-2 z-50 font-mono text-xs text-muted-foreground"
    >
      loading exam code
    </div>
  );
};
